import XLRLogger from '../helpers/logger';
import { ILaneEnvironmentVars, RetailElectronAPI } from './RetailElectronAPI';

const ElectronHelper = {
  async getBaseURL(): Promise<string> {
    if (ElectronHelper.isElectron()) {
      const envVars = RetailElectronAPI.getEnvironmentVariables();
      logEnvVarsHaveBeenRead(envVars);

      return Promise.resolve(`${envVars['API_HOST']}:${envVars['API_PORT']}`);
    } else {
      return Promise.resolve('');
    }
  },
  async getTouchpointIdFromEnvironmentVariable(): Promise<string | undefined> {
    if (ElectronHelper.isElectron()) {
      const envVars = RetailElectronAPI.getEnvironmentVariables();
      logEnvVarsHaveBeenRead(envVars);

      return Promise.resolve(envVars['TOUCHPOINT_ID']);
    } else {
      return Promise.resolve(undefined);
    }
  },
  isElectron(): boolean {
    // test if the api exists
    return !!RetailElectronAPI;
  },
};

function logEnvVarsHaveBeenRead(envVars: ILaneEnvironmentVars): void {
  XLRLogger.info({
    message: 'Environment variables read',
    source: 'ElectrionHelper.ts',
    data: envVars,
  });
}

export default ElectronHelper;
